<div class="container" *ngIf="message">
  <div class="flex justify-center w-full">  <div class="py-2 text-white flex items-center gap-8">
    <p class="m-0">{{message}}</p>
    <button class="bg-secondary px-4 py-2 rounded-xl cursor-pointer poppins-regular text-white" [routerLink]="'/subscription'">Subscribe now</button>
  </div>
</div>
</div>
